import Ext from "Ext";
import $ from "jquery";
import _ from "underscore";
import TreeNode from "../hierarchySelector/tree/TreeNode";
import HierarchicalSelectorPanel from "../controls/selectorControls/at_hierarchical_selector_panel";
import HierarchySelectorUtil from "../controls/selectorControls/hierarchy_selector_util"
import CustomerNodeRenderer from "../hierarchySelector/customerProjectSelector/CustomerNodeRenderer"
import ProjectNodeRenderer from "../hierarchySelector/customerProjectSelector/ProjectNodeRenderer"
import ArchivedProjectsParentNodeRenderer from "../hierarchySelector/customerProjectSelector/ArchivedProjectsParentNodeRenderer"
import ArchivedCustomersParentNodeRenderer from "../hierarchySelector/customerProjectSelector/ArchivedCustomersParentNodeRenderer"
import TwoLevelSelection from "../controls/selectorControls/two_level_selection"
import TreeRootNode from "../hierarchySelector/tree/TreeRootNode"
import StringIndex from "../util/StringIndex"
import TreeNodeSet from "../hierarchySelector/tree/TreeNodeSet"
import RpcControlManager from "../rpc_control_manager"
import CoarseSelection from "../enums/CoarseSelection"
import CPSelectorTreeBuilder from "./CPSelectorTreeBuilder"
import {makeMapAndOrderForEntitiesArray} from "../atUtils"
import SimpleCustomersAndProjectsSelectionHelper from './simple_customers_and_projects_selection_helper'

const CustomerProjectSelectorPanel = Ext.extend(HierarchicalSelectorPanel, {
    allItemsOptionValue: "all",

    allItemsOptionLabelKeyNotFiltered: "projects_customers_selector.all_projects_customers",
    allItemsOptionLabelKeyFiltered: "projects_customers_selector.all_projects_customers_filtered",
    customOptionLabelKey: "projects_customers_selector.selected_customers_projects",
    showInactiveLabelKey: "projects_customers_selector.show_archived",

    collapsedCookiesKey: "",
    isCustomersProjectsFiltered: false,

    nonStandardAllSelectedString: "",
    rpcManager: null,

    showEmptyCustomers: false,

    getPredefinedSelectionCallback: function() {
        return CPSelectorServerUtil.getPredefinedState();
    },

    getAllItemsOptionLabelKey: function()
    {
        return this.isCustomersProjectsFiltered ? this.allItemsOptionLabelKeyFiltered : this.allItemsOptionLabelKeyNotFiltered;
    },

    initComponent: function() {
        this.addClass("customer-project-panel");
        this.addClass("hideCustomOptionField");
        CustomerProjectSelectorPanel.superclass.initComponent.call( this );
        this.collapsedCookiesKey += "CollapsedCustomers";
        this.on("afterlayout", function (){
            var parentNode = this.getEl().findParentNode( "div.at-selector-menu",10,true );
            if( parentNode ) parentNode.addClass("customerProjectType");
        }, this);
    },

    saveCollapsedNodesIntoCookies: function() {
        HierarchySelectorUtil.saveCollapsedNodesIntoCookies(this.selectorTree, this.collapsedCookiesKey, TreeNode.TYPE_CUSTOMER);
    },

    canExpandCollapseNodes: function() {
        return true;
    },

    getNodeRenderers: function()
    {
        var selectionHelper = this.getSelectionHelper();

        var result = {};
        result[TreeNode.TYPE_CUSTOMER] = new CustomerNodeRenderer(this.selectorTree, this.selectorFilter, this.getExpandCollapseCallback(), selectionHelper);
        result[TreeNode.TYPE_PROJECT] = new ProjectNodeRenderer(this.selectorTree, this.selectorFilter, selectionHelper);
        result[TreeNode.TYPE_ARCHIVED_PROJECTS_PARENT] = new ArchivedProjectsParentNodeRenderer(this.selectorTree, this.selectorFilter, selectionHelper);
        result[TreeNode.TYPE_ARCHIVED_CUSTOMERS_PARENT] = new ArchivedCustomersParentNodeRenderer(this.selectorTree, this.selectorFilter, selectionHelper);
        return result;
    },

    createTree: function() {
        return new CustomerProjectSelectorTree(this.rootNode, this.createEmptyMessageBuilder(), this.getCollapsedNodeIdsFromCookies());
    },

    makeNodeSet: function(selection) {
        return HierarchySelectorUtil.makeNodeSetByTwoLevelSelection( selection, this.selectorTree.getRootNode(), "c", "p" );
    },

    isTopNodeLevel: function(treeNode) {
        return treeNode.getType() == TreeNode.TYPE_CUSTOMER;
    },

    isLowNodeLevel: function(treeNode) {
        return treeNode.getType() == TreeNode.TYPE_PROJECT;
    },

    isHiddenNodeSelected: function(treeNode) {
        return this.checkHiddenNodeSelectionTemplate(treeNode, function()
        {
            return treeNode.getType() == TreeNode.TYPE_ARCHIVED_PROJECTS_PARENT || treeNode.getValue().archived
        });
    },

    createEmptyMessageBuilder: function() {
        return new CustomerProjectSelectorEmptyMessageBuilder(this.isCustomersProjectsFiltered);
    },

    makeSelectionHelper: function() {
        this.selectionHelper = new SimpleCustomersAndProjectsSelectionHelper({isCustomersProjectsFiltered: this.isCustomersProjectsFiltered})
    },

    getSelection: function(isFullFormed, transformFirstLevelToSecond)
    {
        var mapping = {};
        if (!transformFirstLevelToSecond)
            mapping[TreeNode.TYPE_CUSTOMER] = TwoLevelSelection.FIRST_LEVEL_INDEX;
        mapping[TreeNode.TYPE_PROJECT] = TwoLevelSelection.SECOND_LEVEL_INDEX;
        return HierarchySelectorUtil.makeSelectionFromNodeSet(this.getSelectedNodeSet(), isFullFormed, mapping, 4);
    },

    /**
     * Get single selected customer or project if only one item is selected and null otherwise
     */
    getSingleSelectedCustomerOrProject: function() {
        if (this.isCustomOptionSelected())
        {
            var selection = this.getSelection(true);
            var customers = selection.getFirstLevel();
            var projects = selection.getSecondLevel();
            if (customers.length + projects.length == 1)
            {
                return (customers.length == 1) ? customers[0] : projects[0];
            }
        }
        return null;
    },

    initializeSelector: function(initData, predefinedState) {
        this.enableControls();
        // TODO: List of projects, returned by the server, should be sorted by customer name than by project name.
        // TODO: This way we can avoid conversion of customers from array to map. See also RetrieveCustomersProjectsServiceImpl
        var data = makeMapAndOrderForEntitiesArray(initData.customers);

        this.rootNode = new TreeRootNode();
        this.searchIndex = new StringIndex();
        this.allActiveSet = new TreeNodeSet();
        new CPSelectorTreeBuilder(
                this.rootNode,
                initData.projects,
                data.map,
                data.order,
                this.showEmptyCustomers,
                this.createCpSelectorTreeBuilderObserver( this.searchIndex, this.allActiveSet )).buildTree();
        this.createSelectorTree();
        this.buildSelectorTree();
        this.fireSelectionChangeAllowed = false;
        var state = !!predefinedState ? predefinedState : this.getPredefinedSelectionCallback();

        if (this.showInactiveCheckbox && !state.forceHideInactive && this.isCheckShowArchivedCheckboxNeeded(state)) {
            this.showInactiveCheckbox.setChecked(true);
            state.showInactive = true;
        }

        this.setPredefinedParameters(state);
        this.loadState(state);
        
        this.fireSelectionChangeAllowed = true;

        if (this.showShowInactiveCheckbox)
        {
            var anyArchived = _.any(initData.customers, function(c) { return c.archived }) ||
                              _.any(initData.projects, function(p) { return p.archived })
            if (!anyArchived)
                this.showInactiveCheckbox.hide();
        }
    },

    createCpSelectorTreeBuilderObserver: function(searchIndex, allActiveSet)
    {
        return new CPSelectorTreeBuilderObserver( searchIndex, allActiveSet, true );
    },

    isCheckShowArchivedCheckboxNeeded: function(state) {
        var node;
        if (!state.showInactive) {
            var customers = state.selection.getFirstLevel();
            for (var i = 0; i < customers.length; i++) {
                node = this.rootNode.getNodeById(HierarchySelectorUtil.makeTreeNodeId( "c", customers[i] ));
                if (node){
                    if (node.getValue().archived) {
                        return true;
                    }
                }
            }
            var projects = state.selection.getSecondLevel();
            for (var j = 0; j < projects.length; j++) {
                node = this.rootNode.getNodeById(HierarchySelectorUtil.makeTreeNodeId( "p", projects[j] ));
                if (node){
                    if (node.getValue().archived) {
                        return true;
                    }
                }
            }
        }
        return false;
    },

    setGetPredefinedSelectionCallback: function(callback) {
        this.getPredefinedSelectionCallback = callback;
    },

    getAllCustomers: function() {
        var result = [];
        var showArchived = this.getShowInactive();
        var customerNodes = this.rootNode.getChildren();
        for (var i = 0; i < customerNodes.length; i++) {
            if (showArchived || customerNodes[i].active) {
                result.push(customerNodes[i]);
            }
        }
        return result;
    },

    getFilterCallback: function() {
        var context = this;
        return function(entity) {
            return context.getShowInactive() || !entity.archived;
        }
    },

    loadState: function(state) {
        if (this.isAlreadyShown()) {
            CustomerProjectSelectorPanel.superclass.loadState.call(this, state);
        }
    },

    isStateChanged: function() {
        if (this.isAlreadyShown()) {
            return CustomerProjectSelectorPanel.superclass.isStateChanged.call(this);
        } else {
            return false;
        }
    },

    makeSelectionTree: function() {
        //do nothing
    },

    processFirstPanelOpen: function() {
        if (!this.ajaxStarted) {
            CustomerProjectSelectorPanel.superclass.processFirstPanelOpen.call(this);
            this.disableControls();
            var spinner = this.rpcManager.getSpinner();
            if (!spinner) {
                spinner = new Spinner(CPSelectorClientUtil.DEFAULT_SPINNER_OPTS);
                this.rpcManager.setSpinner(spinner);
            }
            spinner.spin(this.treePanel);
            RpcControlManager.saveRpcControlBoundData(this.rpcManager, false);
        }
    },
    
    getControlsForEnabledChange: function () {
        return _.compact(_.flatten([
            this.genericOptions,
            this.customOption,
            this.resetButton,
            this.selectAllButton,
            this.clearButton,
            this.expandAllButton,
            this.collapseAllButton,
            this.hideNonSelectedButton,
            this.filterButton
        ]));
    },

    disableControls: function() {
        this.ajaxStarted = true;
        _.each(this.getControlsForEnabledChange(), function (control) {
            control.disable();
        });
    },

    enableControls: function() {
        this.ajaxStarted = false;
        _.each(this.getControlsForEnabledChange(), function (control) {
            control.enable();
        });
    },

    isAllItemsOptionSelected: function() {
        return this.currentOption.inputValue == this.allItemsOptionValue;
    },

    getOptionValueByStateValue: function(stateValue) {
        return (stateValue == CoarseSelection.ALL) ? this.allItemsOptionValue : this.customOptionValue;
    },

    getStateValueByOptionValue: function(optionValue) {
        return (optionValue == this.allItemsOptionValue) ? CoarseSelection.ALL : CoarseSelection.SPECIFIC;
    },

    getAllSelectedString: function() {
        return (this.isAllItemsOptionSelected() && this.nonStandardAllSelectedString) ? this.nonStandardAllSelectedString : this.currentOption.boxLabel;
    },

    isInnerTooltipsEnabled: function() {
        return false;
    },

    isTooltipEnabled: function(){
        return false;
    },

    onGenericOptionSelect: function(option, checked) {

        if(checked)
        {
            this.addClass("hideCustomOptionField");
        }
        CustomerProjectSelectorPanel.superclass.onGenericOptionSelect.call(this, option, checked);
    },

    onCustomOptionSelect: function(option, checked) {
        if(checked)
        {
            this.removeClass("hideCustomOptionField");
            if(!$.isEmptyObject(this.selectorTree))
            {
                this.selectorTree.refreshScroller();
            }
        }
        CustomerProjectSelectorPanel.superclass.onCustomOptionSelect.call(this, option, checked);
    }

});

Ext.reg("at_customer_project_selector_panel", CustomerProjectSelectorPanel);

export default CustomerProjectSelectorPanel;


// WEBPACK FOOTER //
// ./web/js/cp_selector/at_customer_project_selector_panel.js